module.exports = __webpack_public_path__ + "img/clear.c94dd4f9.svg";